import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./whatsapp.css";

export default function WhatsAppButton() {
  const whatsappNumber = "918171974067"; // no spaces
  const message = encodeURIComponent("Hello, I need help");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <FaWhatsapp size={30} />
      <span className="whatsapp-tooltip">How may I help you?</span>
    </a>
  );
}
